import { FormEvent } from "react";

import { RiFileExcel2Fill } from "react-icons/ri";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Button from "react-bootstrap/Button";

import { Option } from "@/@types/generics/Option";

import { SearchInput } from "@/components/SearchInput";
import { SelectComponent } from "@/components/SelectComponent";

type Props = {
	fullName: string;
	setFullName: (fullName: string) => void;
	setVaccinationStatus: (vaccinationStatus: string) => void;
	handleFilter: (event: FormEvent) => void;
	handleExport: () => void;
	isLoadingExport: boolean;
};

export function TripleViralCitizensFilters({
	fullName,
	setFullName,
	setVaccinationStatus,
	handleFilter,
	handleExport,
	isLoadingExport,
}: Props) {
	const vaccinationOptions: Option<string>[] = [
		{ label: "Todos", value: "" },
		{ label: "Concluído", value: "finished" },
		{ label: "Pendente", value: "pending" },
		{ label: "Em atraso", value: "delayed" },
		{ label: "Perdido", value: "lost" },
		{ label: "Abandono", value: "abandoned" },
	];

	return (
		<Form
			onSubmit={(event) => {
				event.preventDefault();
				handleFilter(event);
			}}
		>
			<Row className="d-flex justify-content-between">
				<Col sm={12} md={12} lg={4} xl={4} className="justify-content-start mb-2">
					<div>
						<label className="form-label text-nowrap">Pesquisar Cidadão:</label>
						<SearchInput
							placeholder="Pesquisar nome"
							value={fullName}
							setValue={setFullName}
						/>
					</div>
				</Col>
				<Col sm={12} md={12} lg={4} xl={4} className="justify-content-start mb-2">
					<div className="d-flex flex-column">
						<label htmlFor={"vaccination-status-select"} className="form-label">
							Status:
						</label>
						<SelectComponent
							id="vaccination-status-select"
							options={vaccinationOptions}
							placeholder="Selecione..."
							onChange={(event) =>
								setVaccinationStatus((event as Option<string>).value)
							}
						/>
					</div>
				</Col>
				<Col
					xs={12}
					sm={6}
					md={2}
					lg={2}
					xl={2}
					className="d-flex align-items-end justify-content-end flex-column my-2"
				>
					<Button
						variant="secondary"
						className="px-2"
						disabled={isLoadingExport}
						onClick={handleExport}
					>
						<RiFileExcel2Fill />
						Exportar
					</Button>
				</Col>
			</Row>
		</Form>
	);
}
